import type { Ref } from 'react';
import useAskTurn from '@/hooks/useAskTurn';
import type { AskAllTrailsArgs } from '@/utils/askAllTrailsApi';
import AskResponse from './AskResponse';

type Props = {
  args: AskAllTrailsArgs;
  ref?: Ref<HTMLDivElement>;
};

/**
 * One question in the Ask chat and its answer, read from that question's own request.
 */
const AskTurn = ({ args, ref }: Props) => {
  const response = useAskTurn(args);

  return (
    <div ref={ref}>
      <AskResponse {...response} isChat request={args.request} />
    </div>
  );
};

export default AskTurn;
